import React from "react";

const OwnItUpBottomBGElement = () => {
  return (
    <svg
      width="70"
      height="97"
      viewBox="0 0 70 97"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_6476_35647)">
        <path
          d="M0 123C0 138.464 12.536 151 28 151C43.464 151 56 138.464 56 123V0C25.0721 0 0 25.0721 0 56V123Z"
          fill="white"
          fillOpacity="0.04"
        />
        <path
          d="M14 139C14 154.464 26.536 167 42 167C57.464 167 70 154.464 70 139V14C39.0721 14 14 39.0721 14 70V139Z"
          fill="white"
          fillOpacity="0.04"
        />
      </g>
      <defs>
        <clipPath id="clip0_6476_35647">
          <rect width="70" height="97" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default OwnItUpBottomBGElement;
